import { createContext, useContext } from 'react';
import { HeroTypes } from '..';

const defaultVariant: HeroTypes.TLocationHeroVariant = 'hero-section-1';

export const VariantContext = createContext<HeroTypes.TLocationHeroVariant>(
  defaultVariant
);

export const useHeroVariant = () => useContext(VariantContext);
